module.exports = __webpack_public_path__ + "img/fold.00b7da48.svg";